
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import SendSmsCode from '@/components/SendSmsCode/index.vue'
import { forgetPasswordReset } from '@/api/login'
import { encryptData } from '@/utils/encryptData'

@Component({
  components: { SendSmsCode }
})
export class changePwd extends Vue {
  @Getter mobile!: string

  pwd1 = ''
  pwd2 = ''
  pwdFieldType = 'password'
  isPwd2Err = false
  pwd2ErrMsg = '两次密码不一致'
  errShakeClass = 'animate__animated animate__headShake'

  mounted() {}

  // input输入限制（英文、数字）独立编码
  formatterInput(value) {
    return value.replace(/[^a-zA-Z\d]/g, '')
  }

  onPwdInput() {
    this.isPwd2Err && (this.isPwd2Err = false)
  }

  onSubmit() {
    if (this.pwd1 != this.pwd2) {
      this.pwd2ErrMsg = '两次密码不一致'
      this.isPwd2Err = true
      return
    }
    const { businessId, mobile, smsCode } = this.$route.query as any
    const params = {
      businessId,
      mobile: encryptData(mobile),
      smsCode,
      password: encryptData(this.pwd1)
    }
    forgetPasswordReset(params)
      .then(() => {
        this.$toast('设置成功')
        this.$router.replace({
          path: '/selectStore',
          query: { from: 'setPwd' }
        })
      })
      .catch((err) => {
        // 有误
        const { msg = '请联系管理员' } = err.data || null
        this.pwd2ErrMsg = msg
        this.isPwd2Err = true
      })
  }

  onIgnore() {
    this.$router.replace({ path: '/selectStore', query: { from: 'setPwd' } })
  }
}
export default changePwd
